'use client'
import * as React from 'react'

import { cn } from '@/lib/utils'

// export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}
export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        'flex h-12 w-full rounded-lg border border-input bg-background p-3 text-base placeholder:text-muted-foreground focus-visible:border focus-visible:outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-grey-100 disabled:text-grey-500',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = 'Input'

export { Input }
